import { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

export function useMultipleMediaUpload(props) {
  PropTypes.checkPropTypes(propTypes, props, 'prop', 'useMultipleMediaUpload')

  const { carouselItems, maxCount, FileItemPath, initialFileValue, setValues, values } = props

  const handleAddAnotherItem = useCallback(() => {
    if (carouselItems.length < maxCount) {
      // add new initial item to carousel items array
      const updatedValues = { [FileItemPath]: [...carouselItems, { id: uuidv4(), ...initialFileValue }] }

      setValues({ ...values, ...updatedValues })
    }
  }, [FileItemPath, carouselItems, values, setValues, maxCount, initialFileValue])

  const handleDeleteItem = useCallback(
    index => {
      // delete item from carousel items array
      let newCarouselItems = [...carouselItems]
      newCarouselItems.splice(index, 1)

      if (newCarouselItems.length === 0) {
        // if all files were removed add empty file to represent UploadAd component
        newCarouselItems.push({ id: uuidv4(), ...initialFileValue })
      }

      const updatedValues = { [FileItemPath]: newCarouselItems }
      setValues({ ...values, ...updatedValues })
    },
    [FileItemPath, carouselItems, setValues, values, initialFileValue]
  )

  return useMemo(
    () => ({
      handleAddAnotherItem,
      handleDeleteItem
    }),
    [handleAddAnotherItem, handleDeleteItem]
  )
}

const propTypes = {
  carouselItems: PropTypes.array.isRequired,
  maxCount: PropTypes.number.isRequired,
  FileItemPath: PropTypes.string.isRequired,
  initialFileValue: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
}
